export default function extractTextFromRichEditorValue(value) {
    return _.trim(value.value !== undefined ? value.value : value);
}



// WEBPACK FOOTER //
// ./src/components/helpers/extractTextFromRichEditorValue.js